import Vue from "vue";
import "regenerator-runtime";
import VueApollo from "vue-apollo";

import App from "./App.vue";
import "./assets/styles/index.css";
import router from "./router.js";
import { auth } from "./firebaseConfig";
import { apolloClient } from "./apollo/apollo";
import { updateAuthenticationState } from "./graphql/mutations";
import { myProjects, getMe } from "./graphql/queries";

Vue.config.productionTip = false;

Vue.prototype.$auth = auth;

// Vue Portals
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

// Vue Formulate
import VueFormulate from '@braid/vue-formulate'
Vue.use(VueFormulate)

// JSON Editor
import VJsoneditor from 'v-jsoneditor'
Vue.use(VJsoneditor)

// Vue Debounce
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

// Vue Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Vue Toast
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
//import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

// Vue Meta
import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

// register global components
import "./core-components/global-exports";

Vue.use(VueApollo);
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      fetchPolicy: 'cache-and-network',
    }
  }
});

// handle page reloads
let app;
auth.onAuthStateChanged(async (user) => {

  if (user) {
    let projects = await apolloProvider.defaultClient.query({
      query: myProjects,
    });

    let me = await apolloProvider.defaultClient.query({
      query: getMe,
    });

    let newAuthenticationState = {
      authenticated: true,
      selectedProject: "none",
      needsToOnboard: true,
      uid: me.data.me.id,
      darkMode: null
    };

    let projectArray = projects.data.projects
    let selectedProject = null;

    if (projectArray.length) {
      newAuthenticationState.needsToOnboard = false;

      selectedProject = projects.data.projects.filter(project => project.active)[0] ? projects.data.projects.filter(project => project.active)[0].id : null;
      
      newAuthenticationState.selectedProject = selectedProject;
    }

    await apolloProvider.defaultClient.mutate({
      mutation: updateAuthenticationState,
      variables: newAuthenticationState,
    });

    let route = router.currentRoute;

    if (route.name === 'Login') {
      router.push({ name: 'Project', query: {
        project: selectedProject, ...route.query
      } });
    }

    if (route.name === 'SignUp') {
      router.push({ name: 'Onboarding', query: { ...route.query } })
    }
    
  } else {
    await apolloProvider.defaultClient.resetStore();
  }

  app = new Vue({
      el: "#app",
      router,
      apolloProvider,
      render: (h) => h(App),
  });
  
});
